import { render } from "./ThongBao.vue?vue&type=template&id=0a323db3&scoped=true"
import script from "./ThongBao.vue?vue&type=script&lang=js"
export * from "./ThongBao.vue?vue&type=script&lang=js"

import "./ThongBao.vue?vue&type=style&index=0&id=0a323db3&lang=css"
import "./ThongBao.vue?vue&type=style&index=1&id=0a323db3&lang=scss&scoped=true"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a323db3"]])

export default __exports__